export default __webpack_public_path__ + "media/portrait/logo_adidas-d0553086.svg";